import React from "react";
import { Route, Switch } from "react-router-dom";
import useToken from "./auth/token";
import LoginForm from "./auth/login";
import { Button } from "./utils";
import { CompanyList } from "./company";

// Components to use in the routes
import CatalogPage from "./catalog/page";
import SupplierPage from "./supplier/page";
import AssetPage from "./asset/page";
import CompanyPage, { CompanyDetailsPage } from "./company/page";
import "./App.css";

import TermsAndConditionsWrapper, {
  TermsAndConditionsRedirector,
  TermsAndConditions,
} from "storybook-dashboard/contracts/terms";
import { getAuthHost } from "storybook-dashboard/auth/utils";
import { AuthContext } from "storybook-dashboard/auth/context";

import NavBar from "./navbar";
import NavBarBrand from "./brand";
import { SupportDropdown } from "./support";
import HomePage from "./home";

export function AppRouter() {
  const { isAuthenticated } = useToken();

  if (!isAuthenticated) {
    return <HomePage />;
  }

  return (
    <Switch>
      {/* Terms and conditions page */}
      <Route exact path="/terms" component={TermsAndConditions} />
      <Route exact path="/company" component={CompanyPage} />
      <Route exact path="/company/:companyId" component={CompanyDetailsPage} />
      <Route exact path="/company/:companyId/catalog" component={CatalogPage} />
      <Route
        exact
        path="/company/:companyId/supplier"
        component={SupplierPage}
      />
      <Route
        exact
        path="/company/:companyId/asset/:type/:id"
        component={AssetPage}
      />
      <Route path="/" component={WelcomeMessage} />
    </Switch>
  );
}

export function WelcomeMessage() {
  const {
    isAuthenticated,
    token,
    decodeToken,
    getTokenExpiryTime,
    signOut,
    refreshToken,
  } = useToken();

  if (!isAuthenticated) {
    return <LoginForm />;
  }

  const payload = decodeToken(token);

  return (
    <div className="container mt-3">
      {/* <h3>Welcome {payload.first_name || payload.username}</h3>

      <div>
        <pre>{JSON.stringify(payload, null, 2)}</pre>
      </div>

      <div>
        Token expires in <span>{getTokenExpiryTime(token).toFixed(2)}</span>{" "}
        seconds
      </div>

      <Button text="Logout" onClick={() => signOut()} />
      <Button text="Refresh token" onClick={() => refreshToken()} />

      <hr /> */}

      <CompanyList />
    </div>
  );
}

function App() {
  return (
    <>
      <AuthContext.Provider value={{ host: getAuthHost() }}>
        <TermsAndConditionsRedirector />
        <NavBar
          brand={<NavBarBrand />}
          preUserItems={null}
          include_myprofile={false}
          createText={""}
        />
        <AppRouter />
      </AuthContext.Provider>
      ;
    </>
  );
}

export default App;
